import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'public-investments';

export function useGetAllPublicInvestments(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetPublicInvestment(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreatePublicInvestment() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdatePublicInvestment({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeletePublicInvestment({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
